<template>
    <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vue-headful :title="$t('bugg-list')" />

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <!-- ФИЛЬТРЫ -->
            <ListFilters ref="ListFilters" @closesidebar="toggleSidebar" :itemHandler="infiniteHandle" />
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <!-- Поиск -->
            <div class="flex border d-theme-dark-bg items-center">
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"/>
            </div>

            <!-- список студентов -->
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_bug_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                :key="$vs.rtl"
                @ps-y-reach-end="infiniteHandle">

                    <ul v-if="bugLists.length">
                        <li
                            class="todo_todo-item cursor-pointer"
                            v-for="(item, index) in bugLists"
                            @click="selectItem(item)"
                            :key="`d_${index}`"
                            :style="[{transitionDelay: (index * 0.1) + 's'}]">

                            <ListItem :item="item" />

                        </li>
                    </ul>

                    <!-- Выводим сообщение если данных нет -->
                    <div class="mt-4 ml-5 mr-5" v-if="emptyMessage">
                        <vs-alert active="true">
                            {{$t('no_data_text')}}
                        </vs-alert>
                    </div>

                <!-- В этот див выводил лоадер -->
                <div id="infinite_loader" class="vs-con-loading__container"></div>
            </component>
        </div>

        <vs-popup
            :title="$t('views')"
            :active.sync="activePrompt">
                <Modal v-if="select" :item="select" />
        </vs-popup>

        <div class="pyro">
            <div class="before"></div>
            <div class="after"></div>
        </div>
    </div>
</template>

<script>
import bugList from '@/store/modules/bug_list.js'
import ListFilters from './ListFilters.vue'
import Modal from './Modal.vue'
import ListItem from './ListItem.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import { mapActions, mapGetters } from 'vuex'

// Создаем переменную таймера глобально
let searchId;

export default {
    data() {
        return {
            isSidebarActive: true,
            loading: false,
            activePrompt: false,
            select: null,
            emptyMessage: false,
            clickNotClose: true,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            }
        };
    },
    components: {
        ListFilters,
        VuePerfectScrollbar,
        ListItem,
        Modal
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed: {
        windowWidth() { return this.$store.state.windowWidth },
        bugLists() {
            return this.$store.state.bug_list.bug_list
        },
        infiniteStatus: {
            get() {
                return this.$store.state.bug_list.infiniteStatus
            },
            set(value) {
                this.$store.commit("bug_list/SET_INF_STATUS", value)
            }
        },
        page: {
            get() {
                return this.$store.state.bug_list.page
            },
            set(value) {
                this.$store.commit("bug_list/SET_PAGE", value)
            }
        },
    },
    created: function() {
        // Регистрируем стор
        if(!this.$store.hasModule('bug_list'))
            this.$store.registerModule('bug_list', bugList)
        this.setSidebarWidth()
        //this.searchAggregate()
    },
    methods: {
        ...mapActions({
            fetchBugList: 'bug_list/fetchBugList'
        }),
        selectItem(item) {
            this.select = item
            this.activePrompt = true
        },
        infiniteHandle({update = false}) {
            // Если update = true запрашиваем список заного с новыми параметрами
            if(update) {
                this.infiniteStatus = true
                this.page = 0
            }

            // Запрашщиваем список пользователей
            this.bugListHandler()
        },
        async bugListHandler() {
            if(!this.loading && this.infiniteStatus) {
                this.loading = true
                this.emptyMessage = false
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '#infinite_loader',
                        scale: 0.6
                    })
                })

                try {
                    this.page = this.page+1
                    const res = await this.fetchBugList({page: this.page, route: this.$route})

                    // Если на первой странице данных нет вообще, выводим сообщение
                    if(!res || this.page === 1 && !res.results.length) this.emptyMessage = true

                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if(!res || !res.next) this.infiniteStatus = false
                } catch({detail}) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger',
                    })
                } finally {
                    this.loading = false
                    this.$vs.loading.close('#infinite_loader > .con-vs-loading')
                }
            }
        },
        toggleSidebar (value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return
            this.isSidebarActive = value
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                this.isSidebarActive = this.clickNotClose = true
            }
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.infinite_bug_scroll_wrapper{
    height: 100%;
}
</style>

<style lang="scss" scoped>
$particles: 50;
$width: 500;
$height: 500;

// Create the explosion...
$box-shadow: ();
$box-shadow2: ();
@for $i from 0 through $particles {
  $box-shadow: $box-shadow,
               random($width)-$width / 2 + px
               random($height)-$height / 1.2 + px
               hsl(random(360), 100, 50);
  $box-shadow2: $box-shadow2, 0 0 #fff
}
@mixin keyframes ($animationName) {
    @-webkit-keyframes #{$animationName} {
        @content;
    }

    @-moz-keyframes #{$animationName} {
        @content;
    }

    @-o-keyframes #{$animationName} {
        @content;
    }

    @-ms-keyframes #{$animationName} {
        @content;
    }

    @keyframes #{$animationName} {
        @content;
    }
}

@mixin animation-delay ($settings) {
    -moz-animation-delay: $settings;
    -webkit-animation-delay: $settings;
    -o-animation-delay: $settings;
    -ms-animation-delay: $settings;
    animation-delay: $settings;
}

@mixin animation-duration ($settings) {
    -moz-animation-duration: $settings;
    -webkit-animation-duration: $settings;
    -o-animation-duration: $settings;
    -ms-animation-duration: $settings;
    animation-duration: $settings;
}

@mixin animation ($settings) {
    -moz-animation: $settings;
    -webkit-animation: $settings;
    -o-animation: $settings;
    -ms-animation: $settings;
    animation: $settings;
}

@mixin transform ($settings) {
    transform: $settings;
    -moz-transform: $settings;
    -webkit-transform: $settings;
    -o-transform: $settings;
    -ms-transform: $settings;
}
.pyro{
    position: fixed;
    z-index: 99999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    &:not(.show){
        display: none;
    }
}
.pyro > .before, .pyro > .after {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  box-shadow: $box-shadow2;
  @include animation((1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards));
}

.pyro > .after {
  @include animation-delay((1.25s, 1.25s, 1.25s));
  @include animation-duration((1.25s, 1.25s, 6.25s));
}

@include keyframes(bang) {
  to {
    box-shadow:$box-shadow;
  }
}

@include keyframes(gravity)  {
  to {
    @include transform(translateY(200px));
    opacity: 0;
  }
}

@include keyframes(position) {
  0%, 19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%, 39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%, 59.9% {
    margin-top: 20%;
    margin-left: 70%
  }
  60%, 79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%, 99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
</style>
